import { render } from "./CxTimeline.vue?vue&type=template&id=1167db13&scoped=true"
import script from "./CxTimeline.vue?vue&type=script&lang=js"
export * from "./CxTimeline.vue?vue&type=script&lang=js"

import "./CxTimeline.vue?vue&type=style&index=0&id=1167db13&scoped=true&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1167db13"]])

export default __exports__